import React, { createContext } from 'react';

export const ActiveOrderMeta = React.createContext({
  activeOrderMeta: {},
  setActiveOrderMeta: () => {}
});

export const OrderNoteContext = createContext();
